module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** /home/rengasturku/nettivanne/~/babel-runtime/core-js/object/define-property.js
 ** module id = 407
 ** module chunks = 0 1 2 3 10 11 12 17 19 20
 **/